export default "__VITE_ASSET__Q26ppjRw__"